export enum SpinState{
    Closed = 'closed',
    Closing = 'closing',
    Open = 'open',
    Close = 'close'
}